import { useCallback } from "react";
import { useField } from "formik";
import { EfsMelcoEfsModelsMappingCondition } from "melco-shared-logic";

export const useProcessingConditions = () => {
  const [
    { value: processingConditions },
    ,
    { setValue: setProcessingConditions },
  ] = useField<EfsMelcoEfsModelsMappingCondition[]>("conditions");

  const addProcessingCondition = useCallback(() => {
    const processingCondition: EfsMelcoEfsModelsMappingCondition = {
      name: "DEFAULT",
      values: "",
      operator: "equal",
      format_detail_id: "",
      xpath_token: "",
    };

    setProcessingConditions([
      ...(processingConditions ?? []),
      processingCondition,
    ]);
  }, [processingConditions, setProcessingConditions]);

  const removeProcessingConditions = useCallback(
    (indicesToRemove: number[]) => {
      setProcessingConditions(
        processingConditions.filter((_, idx) => !indicesToRemove.includes(idx))
      );
    },
    [processingConditions, setProcessingConditions]
  );

  return {
    processingConditions,
    addProcessingCondition,
    removeProcessingConditions,
  };
};
